// src/components/MaintenanceServices.js
import React, { useEffect } from 'react';
import Header from './Header'; // Adjust path if needed
import Footer from './Footer'; // Adjust path if needed
import '../styles/Maintenanceservices.css';
import backgroundImage from '../assets/bg1.jpg';
import smallImage from '../assets/maintananceservice.jpg';

const MaintenanceServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <div
        className="maintenanceservices-container"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundAttachment: 'fixed',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="maintenanceservices-content">
          <div className="text-section">
            <h1>Maintenance Services</h1>
            <p>
              We offer reliable maintenance services to ensure uninterrupted operations for your equipment. Our skilled team provides regular inspections, preventative maintenance, and fast repairs to minimize downtime and maximize productivity.
            </p>
          </div>
          <div className="image-section">
            <img src={smallImage} alt="Maintenance Services" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MaintenanceServices;
